import React, { memo, useMemo, useState, useContext, useCallback } from 'react';
import TriggerViewCard from '@gp/components/TriggerViewCard';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import BarEchartCon from './components/BarEchartCon';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import { useRequest, useUpdateEffect, useMemoizedFn } from 'ahooks';
import {
  fetchStudioOverallProjectsBudgetSpendTrendsData,
  studioOverallProjectsBudgetSpendTrendsDownLoad,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import useData from './hooks/useData';
import { context as Context } from '@gp/components/Context';
import classNames from 'classnames';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';

interface BudgetTrendPropsType {
  className?: string;
  style?: React.CSSProperties;
}

const DEFAULT_PROPS: BudgetTrendPropsType = {
  className: '',
  style: {},
};

function BudgetTrend(props: BudgetTrendPropsType) {
  const { className, style } = props;

  const { filter }: StudioOverallProjectsContextType =
    useContext(Context) || {};

  const [dates, setDates] = useState<{ start_date: string; end_date: string }>({
    start_date: '',
    end_date: '',
  });

  const { loading, data, run } = useRequest(
    fetchStudioOverallProjectsBudgetSpendTrendsData,
    { manual: true },
  );

  const spendTotal = Object.keys(data?.spend || {})?.length || 0;
  // Total Budget固定展示
  const total = spendTotal + 1;

  const { data: orgData, keysMap } = useData({ loading, data, dates });

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'STUDIO_OVERALL_PROJECTS_DEV_BUDGET_SPEND_TRENDS_CSV_SUBMIT',
    excelDownloadLogKey: 'STUDIO_OVERALL_PROJECTS_DEV_BUDGET_SPEND_TRENDS_EXCEL_SUBMIT',
    downloadService: createDownloadService(studioOverallProjectsBudgetSpendTrendsDownLoad),
  });
  const handleDownloadInPage = useMemoizedFn((payload: Record<string, any>) => {
    const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
    handleDownload({
      fileType,
      file_type: Number.parseInt(fileType, 10),
      bo: filter?.bo || [],
      project: filter?.project || [],
      start_date: dates?.start_date,
      end_date: dates?.end_date,
    });
  });

  // const tabs = useMemo(() => {
  //   return [
  //     {
  //       id: 'download',
  //       label: (
  //         <GeneralDownloadBtn
  //           uiType="2"
  //           fileTypes={FILE_TYPES2}
  //           isLoading={isDownloading}
  //           onConfirm={handleDownloadInPage}
  //         />
  //       ),
  //       component: (
  //         <BarEchartCon
  //           loading={loading}
  //           total={total}
  //           data={orgData}
  //           keysMap={keysMap}
  //           onChange={({ start_date, end_date }) => {
  //             setDates({
  //               start_date,
  //               end_date,
  //             });
  //             run({
  //               bo: filter?.bo || [],
  //               project: filter?.project || [],
  //               start_date: start_date,
  //               end_date: end_date,
  //             });
  //           }}
  //         />
  //       ),
  //     },
  //   ];
  // }, [loading, orgData, keysMap, filter, dates, isDownloading, handleDownloadInPage]);

  // 筛选器变化，首次不触发
  useUpdateEffect(() => {
    run({
      bo: filter?.bo || [],
      project: filter?.project || [],
      start_date: dates?.start_date,
      end_date: dates?.end_date,
    });
  }, [filter]);

  return (
    <CardSlot
      className={classNames({
        'dbg-studio-overall-projects-development-budget-trend': true,
        [className as string]: !!className,
      })}
      style={style}
      title="Budget Spend Trends"
      rightDom={
        <GeneralDownloadBtn
          uiType="2"
          fileTypes={FILE_TYPES2}
          isLoading={isDownloading}
          onConfirm={handleDownloadInPage}
        />
      }
    >
      <BarEchartCon
        loading={loading}
        total={total}
        data={orgData}
        keysMap={keysMap}
        onChange={({ start_date, end_date }) => {
          setDates({
            start_date,
            end_date,
          });
          run({
            bo: filter?.bo || [],
            project: filter?.project || [],
            start_date: start_date,
            end_date: end_date,
          });
        }}
      />
    </CardSlot>
  );
}

BudgetTrend.defaultProps = DEFAULT_PROPS;

export default memo(BudgetTrend);
